import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import TrackingForm from "./AddTracking";

export default function EditTracking() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <TrackingForm
      isEdit={true}
      tourId={id}
      onSuccess={() => navigate("/tracking-list")}
    />
  );
}